export function hasProperty<K extends string, T>(
  k: K,
  o: T,
): o is T & Record<K, unknown> {
  return (
    typeof o === 'object' && o !== null && k in (o as Record<string, unknown>)
  );
}
